module.exports = __webpack_public_path__ + "static/about-hero-us-0d5a00d9431bf45792747b6dda750cfe.jpeg";